export const URLParam_AppState = 'app-state';
//# sourceMappingURL=consts.js.map